import { useAuth } from "@de/ist-cloud-auth";

import { apiUrl } from "@/config";

import { ApiError } from "./apiError";

export const customFetch = async <T>(url: string, options: RequestInit): Promise<T> => {
	const { customerId, organisationId, roleId } = useAuth();
	const headers = new Headers(options.headers);
	headers.set("ist-customer-id", customerId.value ?? "");
	headers.set("x-organisation-id", organisationId.value ?? "");
	headers.set("x-role-id", roleId.value ?? "");

	const response = await fetch(`${apiUrl}${url}`, { ...options, headers });
	if (!response.ok) {
		throw new ApiError(`Request failed: ${response.status}`, response.status, await response.text());
	}
	return response.json() as Promise<T>;
};
